import styled from "styled-components";

export const NdaWrapper = styled.div`
 
`